// extracted by mini-css-extract-plugin
module.exports = {"white":"_2fKoLyCDT2kL2Lh0T7K35M","green":"_3pJKG51bE8f6-t0VHCzWSf","red":"UIsbEvBjekvhzgBA2PgoU","blue":"_3Q8I7DsZkittJz4S6iFkDV"};